import { map_element_full, map_full } from '@Api';
import { Map, MapElement, MapElementOrientation, Terrain } from '@Models';
import { inject, injectable } from 'inversify';
import { VersionGameMapper } from './VersionGameMapper';
import { TYPES } from '@Types';

@injectable()
export class MapMapper {
  @inject(TYPES.Mapper.VersionGameMapper)
  private readonly _versionGameMapper!: VersionGameMapper;

  public map(item: map_full): Map {
    return {
      id: item.id,
      name: item.name,
      description: item.description,
      initials: item.initials,
      logo: item.logo ?? null,
      game: this._versionGameMapper.map(item.game),
      elements: item.elements.map(
        (element) =>
          ({
            orientation: this.mapOrientation(element.orientation),
            top:
              element.origin_y === map_element_full.origin_y.TOP
                ? element.from_y
                : undefined,
            bottom:
              element.origin_y === map_element_full.origin_y.BOTTOM
                ? element.from_y
                : undefined,
            left:
              element.origin_x === map_element_full.origin_x.LEFT
                ? element.from_x
                : undefined,
            right:
              element.origin_x === map_element_full.origin_x.RIGHT
                ? element.from_x
                : undefined,
            terrain: {
              id: element.terrain.id,
              name: element.terrain.name,
              size: element.terrain.size,
              logo: element.terrain.logo,
              width: element.terrain.width,
              height: element.terrain.height,
            } satisfies Terrain as Terrain,
          }) satisfies MapElement as MapElement,
      ),
    } satisfies Map as Map;
  }

  private mapOrientation(
    orientation: map_element_full.orientation,
  ): MapElementOrientation {
    switch (orientation) {
      case map_element_full.orientation.VERTICAL:
        return MapElementOrientation.VERTICAL;
      case map_element_full.orientation.DIAGONAL_TOP:
        return MapElementOrientation.DIAGONAL_TOP;
      case map_element_full.orientation.DIAGONAL_BOTTOM:
        return MapElementOrientation.DIAGONAL_BOTTOM;
      default:
        return MapElementOrientation.HORIZONTAL;
    }
  }
}
